import React, { useEffect } from 'react';

// Components
import PlanTrialBanner from 'Dashboard/components/PlanTrialBanner/PlanTrialBanner';
import LimitOfUsersExceededBanner from 'Dashboard/components/LimitOfUsersExceededBanner/LimitOfUsersExceededBanner';
import BannerSunsetLegacyCharma from 'Dashboard/components/BannerSunsetLegacyCharma/BannerSunsetLegacyCharma';

import './BannerManager.scss';

const BannerManager = () => {
  // this ensure's that only 1 banner will render at a time.
  // banners must be functional components and return null if they don't need
  // to be rendered. The banners are rendered based on priority, aka, the first banner
  // that is not null will be rendered.
  const bannerList = [BannerSunsetLegacyCharma(), PlanTrialBanner(), LimitOfUsersExceededBanner()];

  const bannerToRender = bannerList.find(banner => banner !== null);

  useEffect(() => {
    if (bannerToRender) {
      document.body.classList.add('app-has-banner');
    } else {
      document.body.classList.remove('app-has-banner');
    }
  }, [bannerToRender]);

  if (!bannerToRender) return null;

  return <div className="BannerManager">{bannerToRender}</div>;
};

export default BannerManager;
